// extracted by mini-css-extract-plugin
module.exports = {"mobileMovement":"styles_mobileMovement__5zosf","dateAndStatus":"styles_dateAndStatus__2c2Hd"};